module.exports = __webpack_public_path__ + "media/QJ.fa4c5c92.mp4";